import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const RightHeaderWrapper = styled.div<{ $isNegative: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  min-width: 92px;
  ${borderRadius.r1};
  background-color: ${({ $isNegative }) =>
    $isNegative ? 'var(--viz-bearish-soft)' : 'var(--viz-bullish-soft)'};
`;

export const RightHeaderReturnLabel = styled.span`
  ${typographyV2.uiXs};
`;

export const RightHeaderReturnValue = styled.span<{ $isNegative: boolean }>`
  ${typographyV2.uiSm};
  color: ${({ $isNegative }) =>
    $isNegative ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  font-family: var(--font-roboto-mono);
`;
